import { Box } from "@mui/material"

import CustomConditionalActionsTableServer from "../../../components/CustomConditionalActionsTableServerSide"
import { GlobalContext } from "../../../contexts/GlobalContext"
import { useContext, useState } from "react"
import { useNavigate } from "react-router-dom"
import getIconComponent from "../../utils/getIconComponent"
import {
  handleExportDataPdfLGScreen,
  handleExportDataPdfSMScreen,
  handleAllExportDataCSV,
} from "../../utils/reactTableActions/exportToolbarActions"

import normalFormatDate from "../../utils/date/DDMMYYYFormatDate"
import CustomFieldsetAccordion from "../../../components/CustomFieldsetAccordion"
import Swal from "sweetalert2"

import { useQueryClient } from "@tanstack/react-query"

import { api } from "../../../api"

const ACCIONES = {
  OPCION: "Cabecera Unica del Predio (CUP)",
  CREAR: "CUP CREAR",
  BUSCAR: "CUP LEER",
  EDITAR: "CUP EDITAR",
  ELIMINAR: "CUP ELIMINAR",
}

const CabeceraUnicaPredio = () => {
  const queryClient = useQueryClient()
  const navigate = useNavigate()
  const { selectedMenuInfo } = useContext(GlobalContext)
  const [expandedFieldsetAccordion, setExpandedFieldsetAccordion] = useState(true)
  const handleToggleFieldsetAccordion = () => setExpandedFieldsetAccordion((prev) => !prev)

  return (
    selectedMenuInfo?.data?.barraAcciones?.find((action) => action?.acccaption === ACCIONES.OPCION) && (
      <CustomFieldsetAccordion
        title="Cabecera Única del Predio"
        expanded={expandedFieldsetAccordion}
        onToggle={handleToggleFieldsetAccordion}
      >
        <br />
        <CustomConditionalActionsTableServer
          endpoint="/ActivacionDePredios/getAllCabecerasUnicasPredios"
          errorMsgFilterSearch="Error en cargar datos"
          queryKeyModal="CabeceraUnicaPredioAll"
          perPage={10}
          rowActionsWidthTable={180}
          rowActions={(row) => {
            // Buscar todas las acciones necesarias
            const buscarAction = selectedMenuInfo?.data?.barraAcciones?.find(
              (action) => action?.acccaption === ACCIONES.BUSCAR,
            )
            const editarAction = selectedMenuInfo?.data?.barraAcciones?.find(
              (action) => action?.acccaption === ACCIONES.EDITAR,
            )
            const eliminarAction = selectedMenuInfo?.data?.barraAcciones?.find(
              (action) => action?.acccaption === ACCIONES.ELIMINAR,
            )

            const actions = [
              {
                label: buscarAction?.acccaption,
                key: buscarAction?.acccaption,
                // icon: <RemoveRedEyeIcon sx={{ color: "#14AFF7" }} />,
                icon: getIconComponent(buscarAction?.accnameicono, buscarAction?.acctipoico),
                onClick: (row) => {
                  navigate(`buscar`, { state: row.original })
                },
              },
              {
                label: editarAction?.acccaption,
                key: editarAction?.acccaption,
                icon: getIconComponent(editarAction?.accnameicono, editarAction?.acctipoico),
                onClick: (row) => {
                  navigate("editar", { state: row.original })
                },
              },
              {
                label: eliminarAction?.acccaption,
                key: eliminarAction?.acccaption,
                icon: getIconComponent(eliminarAction?.accnameicono, eliminarAction?.acctipoico),
                onClick: async (row) => {
                  const result = await Swal.fire({
                    title: "¿Está seguro que quiere eliminar este predio?",
                    text: `Predio: ${row.original.preid}`,
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Sí, eliminar",
                    cancelButtonText: "Cancelar",
                    confirmButtonColor: "#d33",
                  })

                  if (result.isConfirmed) {
                    try {
                      await api.post("/ActivacionDePredios/deleteSpecificPredio", {
                        preid: row.original.preid,
                      })

                      await Swal.fire({
                        title: "¡Eliminado!",
                        text: "El predio ha sido eliminado correctamente.",
                        icon: "success",
                        confirmButtonText: "Aceptar",
                        confirmButtonColor: "#196C87",
                      })

                      // Invalidar la query para refrescar los datos
                      queryClient.invalidateQueries({ queryKey: ["CabeceraUnicaPredioAll"] })
                    } catch (error) {
                      console.error("Error al eliminar:", error)
                      Swal.fire({
                        title: "Error",
                        text: error.response?.data?.message || "No se pudo eliminar el predio",
                        icon: "error",
                        confirmButtonText: "Aceptar",
                      })
                    }
                  }
                },
              },
            ]

            return actions
          }}
          topToolbarCustomActions={({ table, device }) => {
            const crearAction = selectedMenuInfo?.data?.barraAcciones?.find(
              (action) => action.acccaption === ACCIONES.CREAR,
            )
            const exportarAction = selectedMenuInfo?.data?.barraAcciones?.find(
              (action) => action.acccaption === "EXPORTAR",
            )
            const toolbarActions = [
              {
                label: crearAction?.acccaption,
                key: crearAction?.acccaption,
                icon: getIconComponent(crearAction?.accnameicono, crearAction?.acctipoico),
                onClick: () => {
                  navigate("crear")
                },
              },
              {
                type: "dropdown",
                label: exportarAction?.acccaption,
                key: "exportarDropdown",
                icon: getIconComponent(exportarAction?.accnameicono, exportarAction?.acctipoico),
                actions: [
                  {
                    label: "Exportar PDF",
                    key: "exportarPDF",
                    icon: getIconComponent(exportarAction?.accnameicono, exportarAction?.acctipoico),
                    onClick: ({ columns, data }) => {
                      if (device === "sm") {
                        return handleExportDataPdfSMScreen(
                          columns,
                          data,
                          "Reporte de usuarios",
                          `Reporte de Usuarios ${new Date().toLocaleString()}`,
                        )
                      }
                      handleExportDataPdfLGScreen(
                        columns,
                        table.getCoreRowModel().rows,
                        "Reporte de usuarios",
                        `Reporte de Usuarios ${new Date().toLocaleString()}`,
                      )
                    },
                  },
                  {
                    label: "Exportar CSV",
                    key: "exportarCSV",
                    icon: getIconComponent(exportarAction?.accnameicono, exportarAction?.acctipoico),
                    onClick: ({ data }) => {
                      handleAllExportDataCSV(data, `Reporte de Usuarios ${new Date().toLocaleString()}`)
                    },
                  },
                ],
              },
            ]
            return toolbarActions
          }}
          columnsTable={[
            {
              accessorKey: "ciacodigo",
              header: "Compañía",
              size: 100,
              Cell: ({ cell }) => <span>{cell.getValue()}</span>,
            },
            {
              accessorKey: "preid",
              header: "Matrícula",
              size: 180,
              Cell: ({ cell }) => <span>{cell.getValue()}</span>,
            },
            {
              accessorKey: "preidmat",
              header: "ID Matriz",
              size: 180,
              Cell: ({ cell }) => <span>{cell.getValue()}</span>,
            },
            {
              accessorKey: "precatastro",
              header: "Código Catastral",
              size: 200,
              Cell: ({ cell }) => <span>{cell.getValue()}</span>,
            },
            {
              accessorKey: "tippreid",
              header: "Tipo Predio",
              size: 150,
              Cell: ({ cell }) => <span>{cell.getValue()}</span>,
            },
            {
              accessorKey: "preunidad",
              header: "Unidad",
              size: 150,
              Cell: ({ cell }) => <span>{cell.getValue()}</span>,
            },
            {
              accessorKey: "preubicacion",
              header: "Ubicación",
              size: 250,
              Cell: ({ cell }) => <span>{cell.getValue()}</span>,
            },
            {
              accessorKey: "presuperficie",
              header: "Superficie",
              size: 150,
              Cell: ({ cell }) => <span>{cell.getValue()}</span>,
            },
            {
              accessorKey: "prelindnorte",
              header: "Lindero Norte",
              size: 200,
              Cell: ({ cell }) => <span>{cell.getValue()}</span>,
            },
            {
              accessorKey: "preobslindnorte",
              header: "Obs. Técnica Norte",
              size: 220,
              Cell: ({ cell }) => <span>{cell.getValue()}</span>,
            },
            {
              accessorKey: "prelindsur",
              header: "Lindero Sur",
              size: 200,
              Cell: ({ cell }) => <span>{cell.getValue()}</span>,
            },
            {
              accessorKey: "preobslindsur",
              header: "Obs. Técnica Sur",
              size: 220,
              Cell: ({ cell }) => <span>{cell.getValue()}</span>,
            },
            {
              accessorKey: "prelindeste",
              header: "Lindero Este",
              size: 200,
              Cell: ({ cell }) => <span>{cell.getValue()}</span>,
            },
            {
              accessorKey: "preobslindeste",
              header: "Obs. Técnica Este",
              size: 220,
              Cell: ({ cell }) => <span>{cell.getValue()}</span>,
            },
            {
              accessorKey: "prelindoeste",
              header: "Lindero Oeste",
              size: 200,
              Cell: ({ cell }) => <span>{cell.getValue()}</span>,
            },
            {
              accessorKey: "preobslindoeste",
              header: "Obs. Técnica Oeste",
              size: 220,
              Cell: ({ cell }) => <span>{cell.getValue()}</span>,
            },
            {
              accessorKey: "prelindoarriba",
              header: "Arriba",
              size: 150,
              Cell: ({ cell }) => <span>{cell.getValue()}</span>,
            },
            {
              accessorKey: "prelindoabajo",
              header: "Abajo",
              size: 150,
              Cell: ({ cell }) => <span>{cell.getValue()}</span>,
            },
            {
              accessorKey: "prealicuota",
              header: "Alícuota",
              size: 120,
              Cell: ({ cell }) => <span>{cell.getValue()}</span>,
            },
            {
              accessorKey: "precuerpodif",
              header: "Cuerpo Diferente",
              size: 200,
              Cell: ({ cell }) => <span>{cell.getValue()}</span>,
            },
            {
              accessorKey: "precordenadas",
              header: "Coordenadas",
              size: 200,
              Cell: ({ cell }) => <span>{cell.getValue()}</span>,
            },
            {
              accessorKey: "preestado",
              header: "Estado",
              size: 120,
              Cell: ({ cell }) => <span>{cell.getValue()}</span>,
            },
            {
              accessorKey: "prefecisys",
              header: "Fecha Creación",
              size: 180,
              Cell: ({ cell }) => <span>{cell.getValue()}</span>,
            },
            {
              accessorKey: "preusuisys",
              header: "Usuario Creación",
              size: 180,
              Cell: ({ cell }) => <span>{cell.getValue()}</span>,
            },
            {
              accessorKey: "preestisys",
              header: "Estación Creación",
              size: 180,
              Cell: ({ cell }) => <span>{cell.getValue()}</span>,
            },
            {
              accessorKey: "prefecmsys",
              header: "Fecha Modificación",
              size: 180,
              Cell: ({ cell }) => <span>{cell.getValue()}</span>,
            },
            {
              accessorKey: "preusumsys",
              header: "Usuario Modificación",
              size: 180,
              Cell: ({ cell }) => <span>{cell.getValue()}</span>,
            },
            {
              accessorKey: "preestmsys",
              header: "Estación Modificación",
              size: 180,
              Cell: ({ cell }) => <span>{cell.getValue()}</span>,
            },
          ]}
        />
      </CustomFieldsetAccordion>
    )
  )
}

export default CabeceraUnicaPredio
